import React from 'react';
import MyInput from "../../shared/form/MyInput";

const FIELDS = [
  { path: "place.stret", title: "Dirección" },
  { path: "place.city", title: "Código postal y ciudad" },
  { path: "place.country", title: "Región y país" },
  { path: "place.lat", title: "Latitud (mapa)" },
  { path: "place.lng", title: "Longitud (mapa)" },
  { path: "phone", title: "Teléfono" },
  { path: "whatsapp", title: "WhatsApp" },
  { path: "email", title: "Email público" },
  { path: "emailTemp", title: "Email que recibe el formulario de contacto" }
];

const getPath = (obj, path) => path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);

const StoreInfo = ({ settings, onChange }) => {
  const minMax = settings.scheduleMinMax || [];
  return (
    <div className="card mb-4">
      <div className="card-header bg-primary text-white ff-bobby" style={{ fontSize: "24px" }}>
        DATOS DE LA TIENDA
      </div>
      <div className="card-body container-fluid">
        {FIELDS.map(({ path, title }) =>
          <MyInput key={path} title={title} name={path} value={getPath(settings, path) || ""}
                   onChange={e => onChange(path, e.target.value)}/>
        )}
        <div className="row">
          <div className="col-6">
            <MyInput title="Hora mínima de reserva" name="scheduleMinMax.0" type="number"
                     propsInput={{ min: 0, max: 24 }} value={minMax[0] === undefined ? "" : minMax[0]}
                     onChange={e => onChange("scheduleMinMax.0", parseInt(e.target.value, 10))}/>
          </div>
          <div className="col-6">
            <MyInput title="Hora máxima de reserva" name="scheduleMinMax.1" type="number"
                     propsInput={{ min: 0, max: 24 }} value={minMax[1] === undefined ? "" : minMax[1]}
                     onChange={e => onChange("scheduleMinMax.1", parseInt(e.target.value, 10))}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreInfo;
